var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.832 11.912 24 11.95V6.435l-.467-.034a6.665 6.665 0 0 1-6.142-5.95L17.343 0h-4.805l-.04 19.262c0 1.99-1.773 3.61-3.831 3.61a3.663 3.663 0 0 1 0-7.324c.092 0 .17.01.278.025h.001l.166.022.563.067V10.6l-.472-.03-.104-.007c-.13-.01-.283-.02-.432-.02a8.667 8.667 0 1 0 8.667 8.667V9.594a7.68 7.68 0 0 0 5.498 2.318"
  })));
};
export default SvgTiktok;